import { render, staticRenderFns } from "./TemplateTask.vue?vue&type=template&id=0c84d018&scoped=true"
import script from "./TemplateTask.vue?vue&type=script&lang=js"
export * from "./TemplateTask.vue?vue&type=script&lang=js"
import style0 from "./TemplateTask.vue?vue&type=style&index=0&id=0c84d018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84d018",
  null
  
)

export default component.exports